/* eslint-disable */
import * as Types from './types';

import { MoneyFragmentDoc } from './MoneyFragment';
export type UnitPriceFragment = { __typename?: 'ProductVariant', unitPriceMeasurement?: { __typename?: 'UnitPriceMeasurement', measuredType?: Types.UnitPriceMeasurementMeasuredType | null, quantityUnit?: Types.UnitPriceMeasurementMeasuredUnit | null, quantityValue: number, referenceUnit?: Types.UnitPriceMeasurementMeasuredUnit | null, referenceValue: number } | null, unitPrice?: { __typename?: 'MoneyV2', currencyCode: Types.CurrencyCode, amount: string } | null };

export declare const UnitPriceFragment: import("graphql").DocumentNode;
export const UnitPriceFragmentDoc = /*#__PURE__*/ `
    fragment UnitPriceFragment on ProductVariant {
  unitPriceMeasurement {
    measuredType
    quantityUnit
    quantityValue
    referenceUnit
    referenceValue
  }
  unitPrice {
    ...MoneyFragment
  }
}
    `;